"use strict";

import {init as productListPreviewsInit} from './src/productListPreviews';
import productQtyInputDisplayEstimate from './src/productQtyInputDisplayEstimate';
import {gaProductListImpressions} from "./src/gaProductListImpressions";
import productDetails from './src/product-detail';

productListPreviewsInit();
productQtyInputDisplayEstimate.init();
gaProductListImpressions();
productDetails();
